import { initializeApp, FirebaseApp } from 'firebase/app';
import { getDatabase, Database } from 'firebase/database';
import { getAuth, Auth } from 'firebase/auth';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase yapılandırma
const firebaseConfig = {
  apiKey: "AIzaSyBepOIIGmnM7KHFidi91T0dut_xBLrJefI",
  authDomain: "elitaydinprefabrik.firebaseapp.com",
  projectId: "elitaydinprefabrik",
  storageBucket: "elitaydinprefabrik.firebasestorage.app",
  messagingSenderId: "1013041001056",
  appId: "1:1013041001056:web:b51c5e605f3a73bf5f8905",
  measurementId: "G-8G1ETJ68P5",
  databaseURL: "https://elitaydinprefabrik-default-rtdb.europe-west1.firebasedatabase.app"
};

// Firebase'i başlat
let app: FirebaseApp;
let db: Database;
let auth: Auth;
let storage: FirebaseStorage;
let analytics: Analytics | null = null;

try {
  app = initializeApp(firebaseConfig);
  db = getDatabase(app);
  auth = getAuth(app);
  storage = getStorage(app);
  
  // Analytics sadece browser'da çalışır
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { app, db, auth, storage, analytics };

